export default __webpack_public_path__ + "static/media/TT Norms Pro Light.0371b80f.otf";